var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.78482 22.2152H7.05752V13.6005H14.2516V22.2152H19.5243V8.9106L10.6545 2.22645L1.78482 8.90758V22.2152ZM0 24V8.01821L10.6545 0L21.3091 8.01821V24H12.4667V15.3853H8.84234V24H0Z","fill":"#212121"}));
}

Home.defaultProps = {"width":"22","height":"24","viewBox":"0 0 22 24","fill":"none"};

module.exports = Home;

Home.default = Home;
